require('./hireCardPinSet.scss');
// @vendor
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const React = require('react');
// @utilities
const {formatText, FormattedText } = require('core/i18n').i18n;
const { conditionalClassName } = require('utilities/conditionals/conditionalClassname');
// @commons
const { OKInput } = require('commonsComponents/OKInput');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
// @constants
const VALID_INPUT_REGEX = /^\d{0,4}$/;
// @utilities
const {
    EVENT_CLICK,
    PROC_SELECT_PIN,
    recordLink,
} = require('utilities/tagging');
// @ actions
const hireCardPinSetActions = require('actions/hireCardPinSet');

class HireCardPinSet extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            newPin: props.immHireCardPinSet.get('newPin'),
            newPinConfirmation: props.immHireCardPinSet.get('newPinConfirmation'),
        };

        this.handlePinBlur = this.handlePinBlur.bind(this);
        this.handlePinChange = this.handlePinChange.bind(this);
        this.handlePinFocus = this.handlePinFocus.bind(this);
    }

    componentDidUpdate(prevProps) {
        const {
            immHireCardPinSet,
            onBlur,
        } = this.props;

        //ContractView compatibility, setting pin validity in cardsDetails state
        if ((immHireCardPinSet.get('valid') !== prevProps.immHireCardPinSet.get('valid') && !!onBlur) ||
            (immHireCardPinSet.get('validationForced') !== prevProps.immHireCardPinSet.get('validationForced') && !!onBlur)) {
            onBlur(immHireCardPinSet.get('valid'));
        }
    }

    handlePinBlur(evt) {
        const {
            onBlur,
            setPin,
            validate,
        } = this.props;

        const { name, value } = evt.target;

        setPin(value, name);

        if (!!onBlur) {
            validate();
        }
    }

    handlePinChange(evt) {
        const { name, value } = evt.target;

        if (VALID_INPUT_REGEX.test(value)) {
            this.setState({
                [name]: value
            });
        }
    }

    handlePinFocus() {
        const {
            tealiumEventCategory,
        } = this.props;

        if (!!tealiumEventCategory) {
            recordLink(tealiumEventCategory, PROC_SELECT_PIN, EVENT_CLICK);
        }
    }

    render() {
        const {
            forceValidate,
            immHireCardPinSet,
            onBlur,
            showError,
        } = this.props;

        const newPinLabel = formatText('hireCardPinSet-hireCardPinSet_newPinLabel');
        const newPinLabelRequired = `${newPinLabel} *`;
        const repeatNewPinLabel = formatText('hireCardPinSet-hireCardPinSet_repeatNewPinLabel');
        const repeatNewPinLabelRequired = `${repeatNewPinLabel} *`;
        const messageContainerClass = conditionalClassName('hire-card-pin-set__message-container--with-background', '', 'hire-card-pin-set__message-container');
        
        let newPinErrorState;
        let newPinErrorMessage;
        let newPinConfirmationErrorState;
        let newPinConfirmationRequired;
        let newPinConfirmationNotMatch;
        let newPinConfirmationErrorMessageKey;
        let newPinConfirmationErrorMessage;
        let processErrors = true;
        let subtitleSection = (
            <p className="hire-card-pin-set__subtitle">
                <FormattedText value="hireCardPinSet-hireCardPinSet_subtitle" />
            </p>
        );
        let inputsSection;

        if (!onBlur && immHireCardPinSet.get('isDirty')) {
            processErrors = false;
        }

        if (__CONTACT_CENTER__) {
            if (!immHireCardPinSet.get('validationForced') && !!onBlur) {
                forceValidate();
            }

            subtitleSection = (
                <BlockInfo extraClass="show-data__block-info">
                    <p><FormattedText value="cc_hireCardPinSet-hireCardPinSet_securityImpediment" /></p>
                </BlockInfo>
            );
        } else {
            if (showError && processErrors) {
                if (immHireCardPinSet.get('newPin') === '') {
                    newPinErrorState = true;
                    newPinErrorMessage = formatText('hireCardPinSet-hireCardPinSet_requiredMessage', [newPinLabel]);
                } else if (!immHireCardPinSet.get('newPinIsValid')) {
                    newPinErrorState = true;
                    newPinErrorMessage = formatText('hireCardPinSet-hireCardPinSet_invalidField');
                }
    
                if (immHireCardPinSet.get('newPinConfirmation') === '') {
                    newPinConfirmationRequired = true;
                    newPinConfirmationErrorMessageKey = 'requiredMessage';
                } else if (!immHireCardPinSet.get('newPinConfirmationIsValid')) {
                    newPinConfirmationNotMatch = true;
                    newPinConfirmationErrorMessageKey = 'errorMessage';
                }

                newPinConfirmationErrorState = newPinConfirmationRequired || newPinConfirmationNotMatch;
                newPinConfirmationErrorMessage = formatText(`hireCardPinSet-hireCardPinSet_${newPinConfirmationErrorMessageKey}`, [repeatNewPinLabel]);
            }

            inputsSection = (
                <div className="col-md-5">
                    <div className="hire-card-pin-set__input hire-card-pin-set__input--first">
                        <OKInput
                            errorMessage={newPinErrorMessage}
                            errorState={newPinErrorState}
                            id="new-pin"
                            label={newPinLabelRequired}
                            name="newPin"
                            onBlur={this.handlePinBlur}
                            onChange={this.handlePinChange}
                            onFocus={this.handlePinFocus}
                            type="password"
                            value={this.state.newPin}
                        />
                    </div>
                    <div className="hire-card-pin-set__input">
                        <OKInput
                            errorMessage={newPinConfirmationErrorMessage}
                            errorState={newPinConfirmationErrorState}
                            id="new-pin-confirmation"
                            label={repeatNewPinLabelRequired}
                            name="newPinConfirmation"
                            onBlur={this.handlePinBlur}
                            onChange={this.handlePinChange}
                            type="password"
                            value={this.state.newPinConfirmation}
                        />
                    </div>
                </div>
            );
        }

        return (
            <section className="hire-card-pin-set">
                <header className="hire-card-pin-set__title">
                    <FormattedText value="hireCardPinSet-hireCardPinSet_title" />
                </header>
                {subtitleSection}
                <div className="row">
                    {inputsSection}
                    <div className="col-md-7">
                        <div className={messageContainerClass}>
                            <p className="hire-card-pin-set__message-title">
                                <FormattedText value="hireCardPinSet-hireCardPinSet_messageTitle" />
                            </p>
                            <ul>
                                <li>
                                    <FormattedText value="hireCardPinSet-hireCardPinSet_messageCondition1" />
                                </li>
                                <li>
                                    <FormattedText value="hireCardPinSet-hireCardPinSet_messageCondition2" />
                                </li>
                                <li>
                                    <FormattedText value="hireCardPinSet-hireCardPinSet_messageCondition3" />
                                </li>
                                <li>
                                    <FormattedText value="hireCardPinSet-hireCardPinSet_messageCondition4" />
                                </li>
                                <li>
                                    <FormattedText value="hireCardPinSet-hireCardPinSet_messageCondition5" />
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

HireCardPinSet.propTypes = {
    forceValidate: PropTypes.func.isRequired,
    immHireCardPinSet: PropTypes.object.isRequired,
    onBlur: PropTypes.func,
    setPin: PropTypes.func.isRequired,
    validate: PropTypes.func.isRequired,
    showError: PropTypes.bool,
    tealiumEventCategory: PropTypes.string,
};

HireCardPinSet.defaultProps = {
    showError: true,
};

module.exports.constructor = HireCardPinSet;
module.exports.HireCardPinSet = connect(null,
    {
        forceValidate: hireCardPinSetActions.forceValidate,
        setPin: hireCardPinSetActions.setPin,
        validate: hireCardPinSetActions.validate,
    }
)(HireCardPinSet);
